<template>
  <v-simple-table>
    <tbody class="info-table">
      <tr>
        <td>{{ $t('carDetailsPage.infoTable.vin') }}</td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ info.vin }}</span>
            <CopyButton :text="info.vin" />
          </div>
        </td>
      </tr>
      <tr>
        <td>{{ $t('carDetailsPage.infoTable.registration') }}</td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ info.license_plate_number }}</span>
            <CopyButton :text="info.license_plate_number" />
          </div>
        </td>
      </tr>
      <tr>
      <tr>
        <td>{{ $t('carDetailsPage.infoTable.model') }}</td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ info.model }}</span>
            <CopyButton :text="info.model" />
          </div>
        </td>
      </tr>
      <tr>
        <td>{{ $t('carDetailsPage.infoTable.modelYear') }}</td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ info.model_year }}</span>
            <CopyButton :text="info.model_year" />
          </div>
        </td>
      </tr>
      <tr>        
        <td>{{ $t('carDetailsPage.infoTable.purchasePrice') }}</td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ info.purchase_price }}</span>
            <CopyButton :text="info.purchase_price" />
          </div>
        </td>
      </tr>
      <tr>
        <td>{{ $t('carDetailsPage.infoTable.mileage') }}</td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ info.mileage }}</span>
            <CopyButton :text="info.mileage" />
          </div>
        </td> 
      </tr>
      <tr>
        <td>{{ $t('carDetailsPage.infoTable.status') }}</td>
        <td>
          <div class="d-flex justify-content-between">
            <span>{{ info.status }}</span>
            <CopyButton :text="info.status" />
          </div>
        </td> 
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import CopyButton from "@/components/common/CopyButton.vue";

export default {
  name: "CarDetailInfoTable",
  components: {
    CopyButton
  },
  props: {
    info: Object
  },
  data() {
    return {
      
    }
  },
}
</script>

<style scoped>
.info-table {
  text-align: left;
  font-size: 0.875rem;
  color: #333333;
}
</style>